import { render, staticRenderFns } from "./SpecialOffers.vue?vue&type=template&id=c4367dbc&scoped=true&"
import script from "./SpecialOffers.vue?vue&type=script&lang=js&"
export * from "./SpecialOffers.vue?vue&type=script&lang=js&"
import style1 from "./SpecialOffers.vue?vue&type=style&index=1&id=c4367dbc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4367dbc",
  null
  
)

export default component.exports